import { TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Modal from "modules/Modal/Modal";
import { FormEvent, useCallback, useEffect, useState } from "react";

type SaveProjectMapModalProps = {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => void | Promise<void>;
  saving?: boolean;
};

export default function SaveProjectMapModal({
  open,
  onClose,
  onSave,
  saving = false,
}: SaveProjectMapModalProps) {
  const [mapName, setMapName] = useState("");

  useEffect(() => {
    if (open) setMapName("");
  }, [open]);

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      if (!mapName.trim()) return;
      await onSave(mapName.trim());
    },
    [mapName, onSave]
  );

  const handleClose = useCallback(() => {
    setMapName("");
    onClose();
  }, [onClose]);

  return (
    <Modal open={open} onClose={handleClose} styles={{ width: "500px", height: "auto" }}>
      <MDBox p={2}>
        <MDTypography variant="h5" fontWeight="medium" mb={2}>
          Create Map
        </MDTypography>

        <MDBox component="form" role="form" onSubmit={handleSubmit}>
          <MDBox mb={2}>
            <TextField
              autoFocus
              fullWidth
              label="Map Name"
              variant="outlined"
              value={mapName}
              onChange={(e) => setMapName(e.target.value)}
              disabled={saving}
            />
          </MDBox>

          <MDBox display="flex" justifyContent="flex-end" gap={1}>
            <MDButton variant="outlined" color="secondary" onClick={handleClose} disabled={saving}>
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              color="success"
              type="submit"
              disabled={!mapName.trim() || saving}
            >
              {saving ? "Saving..." : "Save"}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Modal>
  );
}
